// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__H73CD","label":"Section_label__3m6Iq","contentWrap":"Section_contentWrap__1iImD","footer":"Section_footer__uFCjJ","footerInner":"Section_footerInner__2r5R3"};